// /* eslint-disable  */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import { Grid, Stack } from '@mui/material';
import { Button, VideoLoader } from 'components';
import useVideo from 'hooks/video';
import { useDispatch } from 'react-redux';
import { useActivityConfiguration } from 'hooks/config/activityConfig';
import { TimelineState } from '@xzdarcy/react-timeline-editor';
import { useAppSelector } from 'hooks';
import { ActivitySchema, ActivitySchemaClips } from 'store/config/schema';

import TimelinePlayer from './TimelineActions';
import './style.css';
import { updateClip } from 'store/config/activities';
import { RootState } from 'store';
import { useSnack } from 'plugins/snack';
import { useConfigWebsocket } from 'hooks/config/useConfigWebsocket';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import TimelineScale from './TimelineScale';
import AnnotationVideoPlayer from './VideoPlayer';
import AnnotationHeader from './ModuleHeader';
import AddActivity from './AddActivity';

const ActivityAnnotationPage = ({}) => {
  const timelineState = useRef<TimelineState>(null);
  const [labelLoader, setLabelLoader] = useState(false);
  const [isDeleted, setDeleted] = useState<boolean>(false);
  const domRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const timelineRef = useRef<HTMLDivElement>(null);
  const [openModal, setOpenModal] = React.useState(false);
  const timelineWrapperRef = useRef<HTMLDivElement>(null);
  const [time, setTime] = React.useState(0);
  const [activityData, setActivityData] = useState<any>([]);
  const [isPlaying, setIsPlaying] = useState(false);
  const [zoomCount, setZoomCOunt] = useState(0);
  const [showText, setShowText] = useState(false);

  useEffect(() => {
    const paddingValue =
      zoomCount === 1 ? '60px' : zoomCount === 2 ? '65px' : '30px';

    document.documentElement.style.setProperty(
      '--dynamic-padding',
      paddingValue
    );
  }, [zoomCount]);

  const currentConfigId = useSelector(
    (state: RootState) => state.configuration.configuration
  );

  const { messages, sendMessage, socket } = useConfigWebsocket(
    currentConfigId || ''
  );

  const [activityDataPointer, setActivityDataPointer] = useState<number>(
    activityData?.length - 1
  );

  const { duration, reset, videoRef } = useVideo();

  const [loading, setLoading] = useState<boolean>(false);
  const [lastTime, setLastTime] = useState(videoRef.current?.currentTime);
  const [activeUsers, setActiveUsers] = useState<
    Array<{
      user_id: string;
      video_id: string;
    }>
  >([]);
  const dispatch = useDispatch();
  const snack = useSnack();

  const { profile } = useAppSelector((state: RootState) => state.auth);

  const handleMessagesReceived = useCallback((message: any) => {
    const messageData = JSON.parse(message.data);

    const messageType = messageData?.type;
    const data = messageData?.data;
    const pipelineType = message?.pipeline_type;

    switch (messageType) {
      case 'activity_annotation_state':
        setActiveUsers(data);
        break;
      default:
        break;
    }

    switch (pipelineType) {
      case 'auto_label':
        setActivityData((data: any) => [...data, message.data.data]);
        break;
      default:
        break;
    }
  }, []);

  useEffect(() => {
    if (socket?.readyState === WebSocket.OPEN) {
      socket.addEventListener('message', handleMessagesReceived);
    }
  }, [socket?.readyState]);

  const {
    currentCameraId,
    activity,
    currentCamera,
    syncActivity,
    isLoadingListConfig,
    handlerefresh
  } = useActivityConfiguration();
  const [cameras, setCameras] = useState<any>([]);
  const isCurrentVideoEnabled = useMemo(() => {
    const userVideo = activeUsers.find(d => d.video_id === currentCameraId);
    if (!userVideo) return true;
    if (userVideo.user_id === profile?.id) return true;
    return false;
  }, [activeUsers, videoRef?.current?.duration]);

  useEffect(() => {
    if (currentCameraId && socket) {
      if (socket?.readyState === WebSocket.OPEN) {
        sendMessage(
          JSON.stringify({
            event: 'current_camera',
            data: {
              camera_id: currentCameraId,
              user_id: profile?.id
            }
          })
        );
      }
    }
  }, [currentCameraId, socket?.readyState]);

  useEffect(() => {
    handlerefresh();
  }, []);

  const loadingVideo = currentCamera?.lowres_url ? false : true;
  const allActivities = useSelector((state: RootState) => state.activities);

  const shouldContinue = useCallback(() => {
    // Check if any activity is missing or named "free"
    const hasInvalidActivity = allActivities.data.some(
      data => !data?.activity || data?.activity.trim().toLowerCase() === 'free'
    );

    if (hasInvalidActivity) {
      snack({
        message: 'Activity name cannot be or empty.',
        severity: 'error'
      });
      return;
    }

    // Original camera check logic
    let vidCount = 0;
    const cameraObjects = cameras?.reduce((data: any, camera: any) => {
      data[camera.id] = 0;
      return data;
    }, {});

    allActivities?.data.forEach(clip =>
      clip?.clips.forEach(data => (cameraObjects[data?.camera_id] = +1))
    );

    Object.values(cameraObjects).map(data =>
      data === 0 ? (vidCount = 1) : (vidCount = vidCount)
    );

    if (vidCount === 1) {
      snack({
        message: 'Please annotate remaining videos.',
        severity: 'info'
      });
    } else {
      syncActivity(activityData[activityDataPointer]);
      navigate(`/train/workflowconfig/:spatiotemporal`);
    }
  }, [
    cameras,
    allActivities,
    activityData,
    activityDataPointer,
    snack,
    navigate
  ]);

  useEffect(() => {
    if (messages) {
      const msg = JSON.parse(messages);
      const data = msg?.data;
      const cameraId = data?.camera_id;
      const url = data?.lowres_url;
    }
  }, [messages]);

  const [isAutoSave, setAutoSave] = useState(false);
  useEffect(() => {
    if (isAutoSave || isDeleted) {
      const handler = setTimeout(() => {
        // Check if any activity is missing or named "free"
        const hasInvalidActivity = allActivities.data.some(
          data =>
            !data?.activity || data?.activity.trim().toLowerCase() === 'free'
        );

        if (hasInvalidActivity) {
          snack({
            message: 'Activity name cannot be free or empty.',
            severity: 'error'
          });
          return;
        }

        // Proceed with saving if all activities are valid
        syncActivity(activityData[activityDataPointer])
          .then(() => setDeleted(false))
          .catch(() => {
            snack({
              message: 'Could not saved the changes.',
              severity: 'error'
            });
          });
      }, 500);

      // Cleanup the timeout if activityData changes before 500ms
      return () => {
        clearTimeout(handler);
      };
    }
  }, [
    activityData,
    activityDataPointer,
    isAutoSave,
    isDeleted,
    allActivities,
    snack
  ]);

  useEffect(() => {
    const clips: ActivitySchemaClips[] = [];

    activity?.forEach((activity: any) => {
      activity.clips.forEach((clip: any) => {
        if (clip.camera_id === currentCameraId) {
          clips.push(clip);
        }
      });
    });
  }, [activity, currentCameraId]);

  const [timelineBackground, setTimeline] = useState('');

  const scale = useMemo(() => {
    let devisor = zoomCount === 0 ? 10 : zoomCount === 1 ? 20 : 40;
    let image =
      zoomCount === 0
        ? `${currentCamera?.video_url}_thumbnail_strip.jpg`
        : zoomCount === 1
        ? `${currentCamera?.video_url}_thumbnail_strip_2x.jpg`
        : `${currentCamera?.video_url}_thumbnail_strip_4x.jpg`;
    setTimeline(image);
    return (videoRef.current?.duration || 0) / devisor;
  }, [duration, zoomCount, currentCameraId]);

  const handleUpdateClip = useCallback(
    ({
      activityId,
      clipId,
      start,
      end
    }: {
      activityId: string;
      clipId: string;
      start: number;
      end: number;
    }) => {
      dispatch(
        updateClip({ activityId, clipId, start_time: start, end_time: end })
      );
    },
    [] // Dependencies
  );

  const [getCropState, setCropState] = useState({
    action_id: '',
    row_id: '',
    start: 0
  });

  const handlePlay = useCallback(() => {
    videoRef.current?.play();
    setIsPlaying(true);
    timelineState.current && timelineState.current.play({ autoEnd: true });
  }, []);

  const handlePause = useCallback(() => {
    videoRef.current?.pause();
    setLoading(false);
    setIsPlaying(false);
    timelineState.current && timelineState.current.pause();
  }, []);

  const handleForward = useCallback(() => {
    if (
      videoRef?.current?.currentTime &&
      videoRef?.current?.currentTime < videoRef.current?.duration
    ) {
      setIsPlaying(false);
      videoRef.current.pause();
      videoRef.current.currentTime = videoRef?.current?.currentTime + 5;
      timelineState.current?.setTime(
        videoRef?.current?.currentTime + 5 < videoRef?.current?.duration
          ? videoRef?.current?.currentTime
          : videoRef?.current?.duration
      );
    }
  }, []);

  const handleBackward = useCallback(() => {
    if (videoRef?.current?.currentTime && videoRef?.current?.currentTime > 0) {
      setIsPlaying(false);
      videoRef.current.pause();
      timelineState.current?.setTime(
        videoRef?.current?.currentTime - 5 < 0
          ? 0
          : videoRef?.current?.currentTime
      );
      videoRef.current.currentTime = videoRef?.current?.currentTime - 5;
    }
  }, []);
  const [isCropDisable, setCropDisable] = useState<boolean>(true);

  const handlePlayerPlay = useCallback(() => {
    timelineState.current?.play({ autoEnd: false });
  }, []);

  const handlePlayerPause = useCallback(() => {
    timelineState.current?.pause();
  }, []);

  const handlePlayerEnd = useCallback(() => {
    timelineState.current?.setTime(0);
    timelineState.current?.pause();
  }, []);

  useEffect(() => {
    if (!videoRef.current) return;
    setIsPlaying(false);

    videoRef.current.addEventListener('play', handlePlayerPlay);
    videoRef.current.addEventListener('pause', handlePlayerPause);
    videoRef.current.addEventListener('ended', handlePlayerEnd);

    return () => {
      videoRef.current?.removeEventListener('play', handlePlayerPlay);
      videoRef.current?.removeEventListener('pause', handlePlayerPause);
      videoRef.current?.removeEventListener('ended', handlePlayerEnd);
    };
  }, [videoRef.current?.duration]);

  // WARNING : Do Not Touch This Patch
  // To auto scroll on zoom
  useEffect(() => {
    if (!videoRef.current || !timelineState.current || !timelineRef.current)
      return;

    const video = videoRef.current;
    const timeline = timelineState.current;
    const timelineEngine = timelineState.current;

    let rafId: number | null = null;

    const updateTimeline = () => {
      if (!video || !timeline || !timelineEngine) return;

      // Get both the time area and edit area grids
      const timeAreaGrid = document.querySelector(
        '.timeline-editor-time-area .ReactVirtualized__Grid'
      );
      const editAreaGrid = document.querySelector(
        '.timeline-editor-edit-area .ReactVirtualized__Grid'
      );

      if (!timeAreaGrid || !editAreaGrid) return;

      const currentTime = video.currentTime;
      const videoDuration = video.duration;

      if (currentTime === undefined || videoDuration === undefined) return;

      const timelineWidth = timeAreaGrid.scrollWidth;
      const visibleWidth = timeAreaGrid.clientWidth;
      const scaleFactor = timelineWidth / videoDuration;
      const cursorPosition = currentTime * scaleFactor;

      // Get the current scroll position
      const currentScroll = timeAreaGrid.scrollLeft;
      const viewportMiddle = currentScroll + visibleWidth / 2;

      // If cursor moves beyond middle point, scroll both grids
      if (cursorPosition > viewportMiddle) {
        const scrollLeft = cursorPosition - visibleWidth / 2;
        const maxScroll = timelineWidth - visibleWidth;
        const finalScroll = Math.max(0, Math.min(scrollLeft, maxScroll));

        // Scroll both grids synchronously
        timeAreaGrid.scrollTo({
          left: finalScroll,
          behavior: 'auto'
        });

        editAreaGrid.scrollTo({
          left: finalScroll,
          behavior: 'auto'
        });
      }

      timelineEngine.setTime(currentTime);

      // Only continue RAF if video is playing
      if (!video.paused) {
        rafId = requestAnimationFrame(updateTimeline);
      }
    };

    // Handle play event
    const handlePlay = () => {
      // Start RAF loop when video plays
      if (!rafId) {
        rafId = requestAnimationFrame(updateTimeline);
      }
    };

    // Handle pause event
    const handlePause = () => {
      // Stop RAF loop when video pauses
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      // Do one final update to ensure timeline is in sync
      updateTimeline();
    };

    // Add event listeners
    video.addEventListener('play', handlePlay);
    video.addEventListener('pause', handlePause);

    // Initial state - start RAF if video is already playing
    if (!video.paused) {
      rafId = requestAnimationFrame(updateTimeline);
    }

    // Cleanup
    return () => {
      video.removeEventListener('play', handlePlay);
      video.removeEventListener('pause', handlePause);
      if (rafId) {
        cancelAnimationFrame(rafId);
      }
    };
  }, [videoRef, timelineState, timelineRef, zoomCount, duration]);

  // To Scroll bottom when new activity added
  useEffect(() => {
    const editAreaGrid = document.querySelector(
      '.timeline-editor-edit-area .ReactVirtualized__Grid'
    ) as HTMLDivElement;

    if (editAreaGrid) {
      setTimeout(() => {
        // Method 1: Using scrollHeight
        const maxScroll = editAreaGrid.scrollHeight;
        editAreaGrid.scrollTop = maxScroll;

        // Method 2: Using the inner container
        const innerContainer = document.querySelector(
          '.timeline-editor-edit-area .ReactVirtualized__Grid__innerScrollContainer'
        ) as HTMLDivElement;

        if (innerContainer) {
          // Get all rows
          const rows = innerContainer.querySelectorAll(
            '.timeline-editor-edit-row'
          );
          if (rows.length > 0) {
            const lastRow = rows[rows.length - 1] as HTMLDivElement;
            lastRow.scrollIntoView({ block: 'end', behavior: 'auto' });
          }
        }

        // Method 3: Force update scrollTop after a brief delay
        setTimeout(() => {
          editAreaGrid.scrollTop = editAreaGrid.scrollHeight;
        }, 50);
      }, 200);
    }
  }, [activityData[activityDataPointer]?.length]);

  const maxEndtime = useMemo(() => {
    return Math.max(
      ...activity
        .map((activity: ActivitySchema) => activity.clips)
        .flat()
        .map((clip: any) => clip.end_time)
    );
  }, [activity]);

  const [currentVideo, setCurrentVideo] = useState(currentCameraId);

  const editorData = useMemo(() => {
    const tempActivities: ActivitySchema[] = [];

    activity?.forEach((activity: any) => {
      const activityClips = activity.clips.filter(
        (c: any) => c.camera_id === currentCameraId
      );

      if (activityClips?.length > 0) {
        tempActivities.push({
          ...activity,
          clips: activityClips
        });
      }
    });

    if (currentVideo !== currentCameraId) {
      setCurrentVideo(currentCameraId);
      setActivityData(() => [tempActivities]);
      setActivityDataPointer(0);
    }

    return tempActivities;
  }, [activity, currentCameraId]);

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      const message =
        'Warning: Refreshing this page may cause data loss. Are you sure you want to continue?';
      event.returnValue = message; // For older browsers
      return message; // For modern browsers
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (currentVideo !== currentCameraId) {
      setCurrentVideo(currentCameraId);
    } else {
      setActivityData((data: any) => [...data, editorData]);
      setLabelLoader(false);
      setActivityDataPointer(activityData?.length);
    }
  }, [editorData]);

  const scaleWidth = timelineRef.current?.clientWidth
    ? zoomCount === 0
      ? timelineRef.current.clientWidth - 248
      : zoomCount === 1
      ? timelineRef.current.clientWidth * 2 - 248
      : timelineRef.current.clientWidth * 4 - 248
    : 1;

  useEffect(() => {
    const checkBuffering = () => {
      const video = videoRef.current;
      if (video) {
        if (isPlaying && video.currentTime === lastTime) {
          setLoading(true); // Show loader if currentTime hasn't changed
        }
        if (video.currentTime >= videoRef.current.duration) {
          setLoading(false);
          setIsPlaying(false);
        } else {
          setLoading(false); // Hide loader if currentTime has changed
          setLastTime(video.currentTime);
        }
      }
    };

    const interval = setInterval(checkBuffering, 500); // Check every 500ms

    return () => {
      clearInterval(interval);
    };
  }, [lastTime, isPlaying]);

  function findNewlyAddedClips(prevEditorData: any, editorData: any): any {
    // If previous editorData is undefined, treat it as empty
    prevEditorData = prevEditorData || [];

    let newlyAddedClips: any = [];

    // Loop through each row of editorData and compare the clips
    editorData.forEach((row: any) => {
      // Find the matching row in prevEditorData
      const prevRow = prevEditorData?.find((prev: any) => prev.id === row.id);

      if (prevRow) {
        // If row exists, find clips that are in the current row but not in the previous row
        const newClips = row.clips
          .filter(
            (clip: any) =>
              !prevRow.clips.some((prevClip: any) => prevClip.id === clip.id)
          )
          .map((clip: any) => ({ rowId: row.id, clipId: clip.id, ...clip }));

        newlyAddedClips = [...newlyAddedClips, ...newClips];
      } else {
        // If the row is new, all clips in this row are new, add the rowId as well
        const newClips = row.clips.map((clip: any) => ({
          rowId: row.id,
          clipId: clip.id,
          ...clip
        }));
        newlyAddedClips = [...newlyAddedClips, ...newClips];
      }
    });

    if (newlyAddedClips?.length === 1) {
      setCropState({
        action_id: newlyAddedClips[0]?.clipId,
        row_id: newlyAddedClips[0]?.rowId,
        start: newlyAddedClips[0]?.start_time
      });
    }

    return newlyAddedClips;
  }

  const prevEditorDataRef = useRef<any>(undefined); // Initialize useRef with type
  useEffect(() => {
    const prevEditorData = prevEditorDataRef.current;
    findNewlyAddedClips(prevEditorData, editorData);
    prevEditorDataRef.current = editorData;
    if (activityData.length > 1) {
      if (activityData[activityDataPointer - 1]?.length === 0) {
        setActivityData([activityData[activityDataPointer]]);
        setActivityDataPointer(0);
      }
    }
  }, [activityData]);

  return (
    <div className="w-full p-4 flex flex-col gap-2">
      <AnnotationHeader
        isAutoSave={isAutoSave}
        setAutoSave={setAutoSave}
        currentConfigId={currentConfigId}
        setCameras={setCameras}
        cameras={cameras}
      />
      {labelLoader && (
        <div
          style={{
            position: 'absolute',
            height: '100vh',
            width: '100vw',
            display: 'flex',
            justifyContent: 'center',
            zIndex: 100,
            alignItems: 'center',
            top: 0,
            left: 0,
            backgroundColor: '#00000090'
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            <span className="loader"></span>
            <div
              style={{
                textAlign: 'center',
                color: 'white',
                fontWeight: 'bold'
              }}
            >
              Fetching Annotations, Please do not refresh.
            </div>
          </div>
        </div>
      )}
      <Grid
        container
        spacing={2}
        style={{
          overflowY: 'auto'
        }}
      >
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item lg={3} md={12}></Grid>
            <Grid item lg={6} md={12}>
              {/* Annotation Video Player */}
              <AnnotationVideoPlayer
                isCurrentVideoEnabled={isCurrentVideoEnabled}
                showText={showText}
                setShowText={setShowText}
                timelineState={timelineState}
                loading={loading}
                isPlaying={isPlaying}
                handleBackward={handleBackward}
                handlePlay={handlePlay}
                handlePause={handlePause}
                videoRef={videoRef}
                reset={reset}
                handleForward={handleForward}
              />
            </Grid>
            <Grid item xs={12}>
              {!isLoadingListConfig ? (
                <div
                  className="timeline-editor-engine"
                  ref={timelineRef}
                  style={{ height: '19vh', marginTop: '-15px' }}
                >
                  <div className="pr-[10px] h-full flex flex-col">
                    {/* Timeline Actions Add, Replicate, LabelAssist, Zoomin, Zoom out */}
                    <TimelinePlayer
                      scale={scale}
                      currentConfigId={currentConfigId}
                      allVideo={cameras}
                      setLabelLoader={setLabelLoader}
                      activity={activity}
                      videoPath={currentCamera?.video_path}
                      isCurrentVideoEnabled={isCurrentVideoEnabled}
                      time={time}
                      editorData={editorData}
                      currentCameraId={currentCameraId}
                      currentCamera={currentCamera}
                      setActivityData={setActivityData}
                      getCropState={getCropState}
                      loadingVideo={loadingVideo}
                      showText={showText}
                      zoomCount={zoomCount}
                      setZoomCOunt={setZoomCOunt}
                      timelineState={timelineState}
                      handlePlay={handlePlay}
                      activityDataPointer={activityDataPointer}
                      setActivityDataPointer={setActivityDataPointer}
                      handlePause={handlePause}
                      activityData={activityData}
                      isPlaying={isPlaying}
                      setIsPlaying={setIsPlaying}
                      videoRef={videoRef}
                      onClickAdd={() => {
                        setOpenModal(true);
                        timelineState.current?.pause();
                        videoRef?.current?.pause();
                      }}
                      onClickCrop={() => {
                        handlePause();
                        handleUpdateClip({
                          activityId: getCropState?.row_id,
                          clipId: getCropState?.action_id,
                          start: getCropState?.start,
                          end: videoRef?.current?.currentTime || 5
                        });
                      }}
                      disableCrop={isCropDisable}
                      maxEndtime={maxEndtime}
                    />

                    {/* Timeline Scale, rename & delete activity, edit clips */}
                    <TimelineScale
                      handleForward={handleForward}
                      setDeleted={setDeleted}
                      syncActivity={syncActivity}
                      handleBackward={handleBackward}
                      activityData={activityData}
                      domRef={domRef}
                      timelineState={timelineState}
                      activityDataPointer={activityDataPointer}
                      setActivityData={setActivityData}
                      setActivityDataPointer={setActivityDataPointer}
                      setCropDisable={setCropDisable}
                      videoRef={videoRef}
                      setIsPlaying={setIsPlaying}
                      setCropState={setCropState}
                      handleUpdateClip={handleUpdateClip}
                      timelineRef={timelineRef}
                      duration={duration}
                      scale={scale}
                      zoomCount={zoomCount}
                      getCropState={getCropState}
                      timelineWrapperRef={timelineWrapperRef}
                      scaleWidth={scaleWidth}
                      timelineBackground={timelineBackground}
                    />
                  </div>
                </div>
              ) : (
                <VideoLoader height={400} />
              )}
            </Grid>
            <Stack
              direction="row"
              spacing={2}
              width={'100%'}
              justifyContent={'center'}
              marginTop={'14px'}
            >
              <Button
                variant="outlined"
                version="light"
                disabled={false}
                noTransition={true}
                onClick={() => navigate('/train/videos')}
              >
                Back
              </Button>

              <Button
                variant="outlined"
                version="dark"
                noTransition={true}
                // disabled={!activityData[activityDataPointer]?.length}
                onClick={() => {
                  // Check if any activity is missing or named "free"
                  const hasInvalidActivity = allActivities.data.some(
                    data =>
                      !data?.activity ||
                      data?.activity.trim().toLowerCase() === 'free'
                  );

                  if (hasInvalidActivity) {
                    snack({
                      message: 'Activity name cannot be empty.',
                      severity: 'error'
                    });
                    return;
                  }

                  // Proceed with saving if all activities are valid
                  syncActivity(activityData[activityDataPointer]).then(() => {
                    snack({
                      message: 'Activities saved successfully',
                      severity: 'success'
                    });
                  });
                }}
              >
                Save
              </Button>

              <Button
                variant="outlined"
                version="dark"
                disabled={!activityData[activityDataPointer]?.length}
                onClick={shouldContinue}
                noTransition={true}
              >
                Continue
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
      <AddActivity
        openModal={openModal}
        setOpenModal={setOpenModal}
        currentCameraId={currentCameraId}
        currentCamera={currentCamera}
        videoRef={videoRef}
        setCropDisable={setCropDisable}
        activity={activity}
      />
    </div>
  );
};

export default ActivityAnnotationPage;
